// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"nW","innerWrapper":"oW","tooltipWrapper":"pW","icon":"qW","tooltip":"rW","content":"sW"};